const sixYearsLetter = {
  id: 4,
  dateArchived: '2026-10-24',
  title: 'Six Years of Us',
  isNew: true,
  letterContent: {
    greeting: 'happy 6 years reegan claire oconnor.',
    text: `who thought we'd make it this far haha? i picked one photo from every year to go with this and it took me way longer than it should have.

you're the most thoughtful person i know. every birthday of mine you found a way to make me feel so loved and so seen, and i'm still learning how to give that back to you. i'm gonna spend a long time trying.

i love who you are. the jokes, the blabbing, the mcdonald's order, the sweets. that version of you is my favorite person in the world and i'm so lucky i get to see it.

i can already see where we're headed. a home that's ours, a dog who will definitely love you more than me, a yard, maybe a couple little ones running around, and one day a bonfire by the ocean with everyone we love. until then we have mexico in november and i can't wait to hold you.

thank you for choosing me for six years. thank you for being patient and soft and so completely you. happy anniversary baby, i love you so much reegs. here's to a lot more of us.`,
    photos: [
      {
        afterParagraph: 0,
        src: '/pictures/six-years/01-camping.webp',
        width: 1200,
        height: 1600,
        alt: 'Together at a campsite at night',
        caption: 'november 2020, look at how young we look haha'
      },
      {
        afterParagraph: 0,
        src: '/pictures/six-years/02-sand-dunes.webp',
        width: 1600,
        height: 1200,
        alt: 'A smiling selfie together in the white sand dunes',
        caption: 'white sands, sorry we didn\'t leave earlier that day'
      },
      {
        afterParagraph: 1,
        src: '/pictures/six-years/03-festival.webp',
        width: 1200,
        height: 1600,
        alt: 'Holding hands at an outdoor festival on a sunny day',
        caption: 'dreamville with you, glad we didn\'t leave early'
      },
      {
        afterParagraph: 2,
        src: '/pictures/six-years/04-at-home.webp',
        width: 1200,
        height: 1600,
        alt: 'Reegan sitting on the living room rug with her phone',
        caption: 'our first little home :)'
      },
      {
        afterParagraph: 2,
        src: '/pictures/six-years/05-night-out.webp',
        width: 1200,
        height: 1600,
        alt: 'Dressed up together before a night out',
        caption: 'our second (not so) little home'
      },
      {
        afterParagraph: 2,
        src: '/pictures/six-years/06-lake.webp',
        width: 1600,
        height: 1200,
        alt: 'A selfie together beside a lake with mountains in the background',
        caption: 'love you, little digicam, especially in the pnw'
      },
      {
        afterParagraph: 3,
        src: '/pictures/six-years/07-mountains.webp',
        width: 1600,
        height: 1200,
        alt: 'Hiking together in front of a snow-covered mountain',
        caption: 'rainier day with my favorite person'
      },
      {
        afterParagraph: 3,
        src: '/pictures/six-years/08-ice-cream.webp',
        width: 1200,
        height: 1600,
        alt: 'Reegan smiling with two ice cream cones under autumn leaves',
        caption: 'bro was double-clenching maple creemees'
      },
      {
        afterParagraph: 4,
        src: '/pictures/six-years/09-us.webp',
        width: 1066,
        height: 1600,
        alt: 'Standing close together in a park, touching foreheads',
        caption: 'greatest day of my life'
      }
    ],
    closing: 'yours always',
    signature: 'Alex'
  }
};

export default sixYearsLetter;
